export const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

export const snakeToCamelCase = (key: string) =>
  key.replace(/_(\w)/g, (_, char) => char.toUpperCase())
